import React from "react";
import { LessonCard } from "./LessonCard/LessonCard";
import { PathCard } from "./PathCard/PathCard";
import { ContentCardProps } from "./contentCardTypes";

export const ContentCard: React.FC<ContentCardProps> = props => {
  if (props.contentType === "path") {
    return <PathCard {...props} />;
  }

  return <LessonCard {...props} />;
};
